<!--
 * @Date: 2020-05-20 09:40:26
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-26 14:42:58
 * @FilePath: /xy-pc/src/views/queryCer/look.vue
--> 
<template>
  <div>
    <div class="title">成&nbsp;&nbsp;绩&nbsp;&nbsp;查&nbsp;&nbsp;询</div>
    <div class="form-box">
      <el-form ref="form" label-width="100px" size="mini" class="form">
        <!-- <el-form-item label="姓名：">
          <el-input v-model="real_name" style="width:224px"></el-input>
        </el-form-item> -->
        <el-form-item label="身份证号：">
          <el-input maxlength="18" v-model="identity_card" style="width:224px"></el-input>
        </el-form-item>
        <!-- <el-form-item label="证书编号：">
          <el-input v-model="certificate_no" style="width:224px"></el-input>
        </el-form-item> -->
        <!-- <div class="tips">注：以上三项输入任意两项即可查询。</div> -->
        <div class="submit" @click="toQuery">查&nbsp;&nbsp;询</div>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      real_name: "",
      identity_card: "",
      certificate_no: ""
    };
  },
  computed: {
    queryLength() {
      let count = 0;
      if (!this.identity_card) {
        count++;
      }
      if (!this.real_name) {
        count++;
      }
      if (!this.certificate_no) {
        count++;
      }
      return count;
    }
  },
  methods: {
    toQuery() {
      
      this.$router.push({
        path: "gradeRes",
        query: {
          identity_card: this.identity_card,
          real_name: this.real_name,
          certificate_no: this.certificate_no
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.form-box {
  height: 600px;
  width: 100%;
  padding-top: 172px;
  background-color: #f6f6f6;
  margin-bottom: 20px;
}
.form {
  width: 350px;
  margin: 0 auto;
}
.title {
  text-align: center;
  font-size: 16px;
  color: #000;
  height: 50px;
  line-height: 50px;
  margin-bottom: 0;
  margin-top: 60px;
  font-weight: bold;
  background: -moz-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #000000),
    color-stop(100%, #ffffff)
  );
  background: -webkit-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -o-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -ms-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #2a82e4 0%, #ffffff 100%);
  // background-color: rgba(42, 130, 228, 1);
}
.tips {
  text-align: center;
  color: rgba(80, 80, 80, 1);
  font-size: 14px;
}
.submit {
  width: 329px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background-color: rgba(42, 130, 228, 1);
  font-size: 18px;
  margin: 0 auto;
  border-radius: 4px;
  margin-top: 50px;
  cursor: pointer;
}
</style>>